export default __webpack_public_path__ + "static/promo-bg-c9f71be8e0078d6955b8906cc3eaebb7.png";